import ErgAuthService from '@ergeon/erg-auth';

type OptionalSettings = {
  cookieName?: string;
};

const COOKIE_PARAM_NAME = 'cookieName';
const OPTIONAL_SETTINGS: OptionalSettings = {};
if (import.meta.env.REACT_APP_AUTH_COOKIE_NAME) {
  OPTIONAL_SETTINGS[COOKIE_PARAM_NAME] = import.meta.env.REACT_APP_AUTH_COOKIE_NAME;
}

export const authService = new ErgAuthService({
  ...OPTIONAL_SETTINGS,
  appId: 'ergeon',
  idService: `${import.meta.env.API_HOST_SERVICE_ID}/`,
  userDetailsEndpoint: `${import.meta.env.API_HOST}/api/v1/authenticate/admin/`,
  level: import.meta.env.MODE as 'development' | 'staging' | 'production' | undefined,
});

export default authService;
